export default "__VITE_ASSET__CCh_$P3J__"